import { render, staticRenderFns } from "./NsPhoneNumberLib.vue?vue&type=template&id=2d825556&scoped=true&"
import script from "./NsPhoneNumberLib.vue?vue&type=script&lang=js&"
export * from "./NsPhoneNumberLib.vue?vue&type=script&lang=js&"
import style0 from "./NsPhoneNumberLib.vue?vue&type=style&index=0&id=2d825556&lang=scss&scoped=true&"
import style1 from "./NsPhoneNumberLib.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d825556",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d825556')) {
      api.createRecord('2d825556', component.options)
    } else {
      api.reload('2d825556', component.options)
    }
    module.hot.accept("./NsPhoneNumberLib.vue?vue&type=template&id=2d825556&scoped=true&", function () {
      api.rerender('2d825556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsPhoneNumberLib.vue"
export default component.exports